import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,  LoadingController, ToastController, AlertController, DateTime, Platform, Toast } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B01SalesPage } from '../b01-sales/b01-sales';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { B08PrinterPage } from '../b08-printer/b08-printer';
import { Storage } from '@ionic/storage';
import crc32 from 'crc/crc32';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { stringify } from 'querystring';  // [YOW:22/07/2020:CR/MPOS/20-03]:Added

/**
 * Generated class for the B01D02SalesPaymentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface soInfo{
  SO_ID: number;
  SO_NO: string;
  CARD: string;
  DATETIME: string;
  TOTAL: number;
  TOTAL_TAX: number;
  GRAND_TOTAL: number;

  SO_STATUS_ID: number;
  STATUS: string;

  USER_ID: number;
  USER_NAME: string;
}

interface paymentTypeInfo {
	PAYMENT_TYPE_ID: number;
	TYPE: string;
	AUTHORIZE: string;
	PAYMENT_TYPE_ACTIVE: string;
}

interface paymentSubTypeInfo {
	PAYMENT_SUB_TYPE_ID: number;
	SUB_TYPE: string;
	PAYMENT_TYPE_ID: number;
	PAYMENT_SUB_TYPE_ACTIVE: string;
}

@IonicPage()
@Component({
  selector: 'page-b01-d02-sales-payment',
  templateUrl: 'b01-d02-sales-payment.html',
})
export class B01D02SalesPaymentPage {

  loading: any;
  Status: any;
  public errorMessage: any = "";

  total_charge_amount: number = 0;
  single_payment:number;
  fast_payment:number = 0;
  total_payment:number = 0;
  SOL_Array = [];
  PAYMENT_Array = [];
  DATA_Array = [];
  SUBMIT_Array = [];
  item_data = [];  
  userName: any;
  userId: any;
  userGrpId: any;
  userRunNo: number = 0;
  userRunNo2: number = 0;
  SERVERDATE: any;
  myDate: string = new Date().toISOString();
  cardNo: any;
  CARD_ID:any;
  DATETIME_SO: any; // [YOW:22/07/2020:CR/MPOS/20-03]:Added

  SO =  { SO_NO:"1234",CARD:"0", DATETIME:"2015-01-09", 
          TOTAL:2,
          TOTAL_TAX:10, GRAND_TOTAL:11, SO_STATUS_ID:1, ACTION_BY:7,
        }

  solData = { SOL_DESC:'', QTY:'', UNIT_PRICE:'', DISC_PERC:'',
              TAX_PERC:'', TOTAL_TAX:'', SOL_TOTAL:'', GRAND_SOL_TOTAL: '',
              INVENTORY_ID:'',
            }
  // [CXY:14/06/2020:CR/MPOS/20-01]:Added WANTOK_GIFT_CARD to paymentData
  paymentData = { AMOUNT_TENDER:0, AMOUNT_CHANGE:'', CORP_CARD_NO:'', AUTH_NO:'',
                  DATETIME:'', PAYMENT_TYPE_ID:'', PAYMENT_SUB_TYPE_ID:'', TYPE: '', 
                  AUTH:'', CORP_NAME:'', WANTOK_GIFT_CARD:''
                }
  paymentBalance:any;
  wantokCard: any = '';
  userBranchId:any;
  soLocalStorage= [];
  companyData = { COMPANY:'', LOGO:'', 
                  ADD1:'', ADD2:'', ADD3:'',
                  CONTACT_NO1:'', 
                  EMAIL:'',
                }
  companyInfo: any;
  userInfo: any;
  receiptInfo: any;
  receiptInfo2: any;
  paymentInfo: any;
  paymentInfo2: any;
  thankyouInfo: any;
  // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
  s_companyInfo: any;
  s_userInfo: any;
  s_receiptInfo: any;
  s_receiptInfo2: any;
  s_paymentInfo: any;
  s_paymentInfo2: any;
  s_thankyouInfo: any;
  // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added
  soArr: soInfo[] = [];
  soItems: soInfo[] = [];
  TOTAL: any;
  TOTAL_TAX: any;
  GRAND_TOTAL: any;
  salesParam: any;
  Layby_SO_ID: any = 0;
  LOCAL_SO_ID: any;
  overlayHidden: boolean = true;
  // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
  overlayHidden_WGC: boolean = true;
  wantokGiftCardNo: any;
  wantokGiftCardPin: any;
  wantokPaymentData = { CardNo:'', CardPin:'', Amount:0};
  f_wantokPay: any = 0;
  // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
  public message: any = "";  // [CXY:03/07/2020:CR/MPOS/20-01]:Added

  data_All= {
              "Param":"1",
              "UserID":"1",
              "Total":"2",
              "CRC":"1164751419",
              "Data":[
                      {
                        "RunNo":"1",
                        "DateTime":"2019-05-20 11:30:12",
                        "SOL_Total":"1",
                        "Branch_ID":"1",
                        "Card":"1234567890",
                        "Action_By":"1",
                        "Status":"3",
                        "Sales":[
                                  {
                                    "SOL_DESC":"KRON 95",
                                    "QTY":"2",
                                    "UNIT_PRICE":"1",
                                    "DISC_PERC":"0",
                                    "TAX_PERC":"1",
                                    "TOTAL_TAX":"1",
                                    "SOL_TOTAL":"1",
                                    "GRAND_SOL_TOTAL":"2",
                                    "INVENTORY_ID":"2"
                                  }
                                ],
                        "Payment":[
                                    {
                                      "AMOUNT_TENDER":"100",
                                      "AMOUNT_CHANGE":"0",
                                      "CORP_CARD_NO":"K1",
                                      "AUTH_NO":"123",
                                      "DATETIME":"2019-05-20 11:35:42",
                                      "PAYMENT_TYPE_ID":"1"
                                    },
                                    {
                                      "AMOUNT_TENDER":"100",
                                      "AMOUNT_CHANGE":"0",
                                      "CORP_CARD_NO":"K1",
                                      "AUTH_NO":"123",
                                      "DATETIME":"2019-05-20 11:35:42",
                                      "PAYMENT_TYPE_ID":"1"
                                    }
                            
                                  ]
                        
                      },
                      {
                        "RunNo":"2",
                        "DateTime":"2019-05-20 11:35:42",
                        "SOL_Total":"2",
                        "Branch_ID":"2",
                        "Card":"1234567891",
                        "Action_By":"1",
                        "Sales":[
                              {
                                "SOL_DESC":"ZRON 97",
                                "QTY":"2",
                                "UNIT_PRICE":"2",
                                "DISC_PERC":"0",
                                "TAX_PERC":"1",
                                "TOTAL_TAX":"1",
                                "SOL_TOTAL":"1",
                                "GRAND_SOL_TOTAL":"1",
                                "INVENTORY_ID":"1"
                              },
                              {
                                "SOL_DESC":"ZRON 97",
                                "QTY":"3",
                                "UNIT_PRICE":"2",
                                "DISC_PERC":"1",
                                "TAX_PERC":"2",
                                "TOTAL_TAX":"2",
                                "SOL_TOTAL":"6",
                                "GRAND_SOL_TOTAL":"8",
                                "INVENTORY_ID":"1"
                              }
                            ],
                        "Payment":[
                              {
                                "AMOUNT_TENDER":"100",
                                "AMOUNT_CHANGE":"0",
                                "CORP_CARD_NO":"Z1",
                                "AUTH_NO":"123",
                                "DATETIME":"2019-05-20 11:35:42",
                                "PAYMENT_TYPE_ID":"1"
                              },
                              {
                                "AMOUNT_TENDER":"100",
                                "AMOUNT_CHANGE":"0",
                                "CORP_CARD_NO":"Z1",
                                "AUTH_NO":"123",
                                "DATETIME":"2019-05-20 11:35:42",
                                "PAYMENT_TYPE_ID":"1"
                              }
                            ]
                      }
                  ]
            }
              
  cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
              }
  paymentTypeData= [];

  paymentTypeArr: paymentTypeInfo[] = [];
	paymentTypeItems: paymentTypeInfo[] = [];
	paymentSubTypeArr: paymentSubTypeInfo[] = [];
	paymentSubTypeItems: paymentSubTypeInfo[] = [];
	alertTitle: any;
	RadioOpen: any;
  RadioResult: any;
  userData= [];
  branchData=[];
  paymentSubTypeData=[];
  screenBig: any;
  tempcardData=[];
  howmanydata:any;
  SO_NO: any;
  plateform: any;
  f_fleetPay: any = 0;
  tempLevelData=[];
  
  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public loadingCtrl: LoadingController, public serviceapi: ServiceApiProvider,
              public alertCtrl : AlertController, public servicegvariable:ServiceGvariableProvider,
              public storage: Storage, public plt: Platform, public platform: Platform,
              private barcodeScanner: BarcodeScanner, private toastCtrl: ToastController,
              ) {

//    this.checkInternet();                 //check internet connection
    if (this.platform.width() > 900) {
      this.screenBig = 'yes';
    } else {
      this.screenBig = 'no';
    }

    if(this.plt.is("core"))
    {
      this.plateform = "web";
      console.log('web')
    }
    else{
      this.plateform = "app";
      console.log('app')
    }

/*     this.paymentData.PAYMENT_TYPE_ID = navParams.get('PAYMENT_TYPE_ID');
    if (this.paymentData.PAYMENT_TYPE_ID == '3'){
      this.cardData = navParams.get('cardData');
      this.cardNo = this.cardData.CARD_NO;
    } */

    if (this.servicegvariable.InternetConnection == 'Online'){
      //load dummy to check internet connection 
      let tbl = ["INVENTORY"];
      let column = ["INVENTORY_ID"];
      let value = ["1"];

      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showonlineLoader();
      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
        this.servicegvariable.InternetConnection = "Online";
        this.loading.dismiss();
        
        // START: CXY ADDED
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];

        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        //this.showLoader();

        this.serviceapi.readdata(json_data,"PAYMENT_TYPE","1","1").then((result) => {		
          this.Status = result["Message"];
          if (this.Status == '1') {
            //this.loading.dismiss();
            let Records = result["Records"];
            this.paymentTypeArr = Records;
            this.paymentTypeItems = this.paymentTypeArr;
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            //this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          //this.loading.dismiss();
        });		
        // END: CXY ADDED

        this.salesParam = navParams.get('salesParam');
        this.total_charge_amount = navParams.get('total_Amount');
        this.Layby_SO_ID = navParams.get('layby_SO_ID');
        console.log(this.salesParam, this.total_charge_amount);

        if (this.salesParam == '1' || this.salesParam == '2') {
          this.userId = sessionStorage.getItem('userid');
          this.userName = sessionStorage.getItem('username');
          this.userGrpId = sessionStorage.getItem('usergroupid');
          this.item_data = navParams.get('Link');
          this.total_charge_amount = navParams.get('total_Amount');

          if (this.userGrpId == '1'){             //if system admin
            this.userBranchId = navParams.get('branch_ID');
          }
          else {
            this.userBranchId = sessionStorage.getItem('userbranchid');
          }

          let sol_length = this.item_data.length;

          for (let i=0; i<sol_length; i++){
            this.SOL_JSON(this.item_data[i]);
          }

          console.log(this.item_data);

          
          this.userId = sessionStorage.getItem('userid');     //user ID

          let tbl = ["USER"];
          let column = ["USER_ID"];
          let value = [this.userId];
          
          let tblkey = ["No"];
          let fktbl = ["No"];
          let fkkey = ["No"];

          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
          let mydata = Object.assign(jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");

          this.showLoader();
          this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
            this.Status = result["Message"];

            if (this.Status == "1"){
              let Records = result["Records"];
/*               this.userRunNo = Records[0]["USER_RUNNO"];
              console.log(this.userRunNo); */
              this.serviceapi.serverdatetime().then((result) => {
                
                this.Status = result["Message"];
                if (this.Status == '1'){
                  let Date = result["Date"];
                  this.SERVERDATE = Date;


                  let tbl = ["BRANCH"];
                  let column = ["BRANCH_ID"];
                  let value = [this.userBranchId];

                  let tblkey = ["All"];
                  let fktbl = ["All"];
                  let fkkey = ["All"];

                  let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                  let mydata = Object.assign(jsonitem);
                  let json_data = this.serviceapi.json_readdata(mydata,"1");

                  this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
                    this.loading.dismiss();
                    this.Status = result["Message"];
                    if (this.Status == '1'){
                      let Records = result["Records"];
                      
                      this.companyData.COMPANY = Records[0].BRANCH_NAME;
                      this.companyData.ADD1 = Records[0].ADDR1;
                      this.companyData.ADD2 = Records[0].ADDR2;
                      this.companyData.ADD3 = Records[0].ADDR3;
                      this.companyData.CONTACT_NO1 = Records[0].CONTACT_NO;
                      this.companyData.EMAIL = Records[0].EMAIL;
                    
                      console.log(this.companyData);
                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                    }

                  }, (err) => {
                    this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                    this.loading.dismiss();
                  });
                }
                else {
                  this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  this.loading.dismiss();
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                this.loading.dismiss();
              });



            }
            else {



              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
            }
          }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
              this.loading.dismiss();
          });
        }
      }, (err) => {
        console.log("online offline")
        this.loading.dismiss();
        
        if (this.servicegvariable.InternetConnection == 'Online'){
          this.servicegvariable.InternetConnection = 'Offline';
          let confirm = this.alertCtrl.create({
            title: 'Offline',
            message: 'No internet connection. Transaction will store at local device until internet connection again.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                console.log('Agree clicked');
                this.offlineInit();
                }
              }
            ]
          });
          confirm.present();
        }  
      });
      
    }
    else {
      console.log("normal offline")

/*       this.storage.get('runningNoData').then((data) => {          //load last running number to prevent running number = 0
        if (data && data.length > 0) {
          this.userRunNo = data;
          console.log(this.userRunNo);
        }
      }); */

      this.offlineInit();
    } 
  }

  offlineInit(){
    console.log("offline now");
    this.storage.get('paymentTypeData').then((data) => {
      this.paymentTypeData = data;
      if (data && data.length > 0) {
        for (let i=0; i<data.length; i++){
            
          let data = JSON.parse(this.paymentTypeData[i]);
          this.paymentTypeArr = data;
        }
        this.paymentTypeItems = this.paymentTypeArr;
      }
    });

    this.salesParam = this.navParams.get('salesParam');
    this.total_charge_amount = this.navParams.get('total_Amount');
    this.Layby_SO_ID = this.navParams.get('layby_SO_ID');

    if (this.salesParam == '1' || this.salesParam == '2') {
      this.userId = sessionStorage.getItem('userid');
      this.userName = sessionStorage.getItem('username');
      this.userGrpId = sessionStorage.getItem('usergroupid');
      this.item_data = this.navParams.get('Link');
      this.total_charge_amount = this.navParams.get('total_Amount');

      /* if (this.userGrpId == '1'){             //if system admin
        this.userBranchId = navParams.get('branch_ID');
      }
      else {
        this.userBranchId = sessionStorage.getItem('userbranchid');
      } */

      let sol_length = this.item_data.length;

      for (let i=0; i<sol_length; i++){
        this.SOL_JSON(this.item_data[i]);
      }

      this.userId = sessionStorage.getItem('userid');     //user ID

      this.storage.get('userData').then((data) => {
        this.userData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.userData[i]);
            console.log(data);
            for (let i=0; i<data.length; i++){
              if (this.userId == data[i].USER_ID){
                /* this.userRunNo = data[i].USER_RUNNO; */
                console.log(this.userRunNo);
              }
            }
          }

          this.storage.get('offlineBranchData').then((data) => {
            this.userBranchId = data;
            console.log(this.userBranchId);
            this.storage.get('branchData').then((data) => {
              this.branchData = data;
              if (data && data.length > 0) {
                for (let i=0; i<data.length; i++){
                    
                  let data = JSON.parse(this.branchData[i]);
                  for (let i=0; i<data.length; i++){
                    if (this.userBranchId == data[i].BRANCH_ID){
                      this.companyData.COMPANY =data[i].BRANCH_NAME;
                      this.companyData.ADD1 = data[i].ADDR1;
                      this.companyData.ADD2 = data[i].ADDR2;
                      this.companyData.ADD3 = data[i].ADDR3;
                      this.companyData.CONTACT_NO1 = data[i].CONTACT_NO;
                      this.companyData.EMAIL = data[i].EMAIL;

                    }
                  }
                }
              }
            });
          
          });
        }
      
      });
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B01D02SalesPaymentPage');
  }

  fastCash(cash){
    this.fast_payment = cash;
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  showonlineLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Check network status...',
        duration: 5000,
    });
    this.loading.present();
  }

  paymentMethod(paymentInfo) {
    this.errorMessage = '';
    this.message = '';  // [CXY:03/07/2020:CR/MPOS/20-01]:Added
    this.paymentData.AUTH_NO = "";
    this.wantokGiftCardNo = ''; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
    this.wantokGiftCardPin = '';  // [CXY:14/06/2020:CR/MPOS/20-01]:Added

		if (this.servicegvariable.InternetConnection == 'Online') {
      this.paymentData.PAYMENT_TYPE_ID = paymentInfo.PAYMENT_TYPE_ID;
      this.paymentData.TYPE = paymentInfo.TYPE;
      this.paymentData.AUTH = paymentInfo.AUTHORIZE;
      
      //clear card info for other payment method (cash, bank, credit card)
      this.cardData =   { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      if(this.paymentData.TYPE == 'FLEET CARD') {
        this.payFleetCard();
      }

      // [CXY:14/06/2020:CR/MPOS/20-01]:Added
      if(this.paymentData.PAYMENT_TYPE_ID == '7') {
        this.popupWantokGiftCard();
        return;
      }
      
      // retrieve payment sub type
      let tbl = ["PAYMENT_SUB_TYPE", "PAYMENT_SUB_TYPE"];
      let column = ["PAYMENT_TYPE_ID", "PAYMENT_SUB_TYPE_ACTIVE"];
      let value = [this.paymentData.PAYMENT_TYPE_ID, "YES"];

      let tblkey = ["PAYMENT_TYPE_ID"];
      let fktbl = ["PAYMENT_TYPE"];
      let fkkey = ["PAYMENT_TYPE_ID"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      
      this.serviceapi.readdata(json_data,"PAYMENT_SUB_TYPE","1","1").then((result) => {
        this.Status = result["Message"];
        if (this.Status == "1") {
          this.loading.dismiss();
          let Records = result["Records"];
          this.paymentSubTypeArr = Records;
          this.paymentSubTypeItems = this.paymentSubTypeArr;
          if (this.paymentSubTypeItems.length > 0)
            this.popPaymentSubType(this.paymentData.AUTH);
        }
        else {
          //this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.paymentData.PAYMENT_SUB_TYPE_ID = '';
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
      });
    }
    else {
      this.paymentData.PAYMENT_TYPE_ID = paymentInfo.PAYMENT_TYPE_ID;
      this.paymentData.TYPE = paymentInfo.TYPE;
      this.paymentData.AUTH = paymentInfo.AUTHORIZE;
      
      this.cardData =   { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      //clear card info for other payment method (cash, bank, credit card)
      if(this.paymentData.TYPE == 'FLEET CARD') {
        this.payFleetCard();
      }

      // [CXY:14/06/2020:CR/MPOS/20-01]:Added
      if(this.paymentData.PAYMENT_TYPE_ID == '7') {
        this.errorMessage = "Internet Offline. Cannot pay with Wantok Gift Card";
        return;
      }

      this.storage.get('paymentSubTypeData').then((data) => {
        this.paymentSubTypeData = data;
        console.log(this.branchData);
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.paymentSubTypeData[i]);
            console.log(data)
            for (let i=0; i<data.length; i++){
              if (this.paymentData.PAYMENT_TYPE_ID == data[i].PAYMENT_TYPE_ID){
                if (data[i].PAYMENT_SUB_TYPE_ACTIVE == "YES"){
                  this.paymentSubTypeArr.push(data[i]);
                }
              }
            }
          }
          this.paymentSubTypeItems = this.paymentSubTypeArr;
          console.log(this.paymentSubTypeItems);
          console.log(this.paymentSubTypeItems.length);
          if (this.paymentSubTypeItems.length > 0)
            this.popPaymentSubType(this.paymentData.AUTH);
        }
      });
    }
	}
	
	popPaymentSubType(authorizeVal) {
		let alertPaymentSubType = this.alertCtrl.create();
		alertPaymentSubType.setTitle("Payment Type");
		
		for(let data of this.paymentSubTypeItems) {
			alertPaymentSubType.addInput({
				type: 'radio',
				name: data.SUB_TYPE,
				label: data.SUB_TYPE.toString(),
				value: data.PAYMENT_SUB_TYPE_ID.toString()
			});
		}
		
		alertPaymentSubType.addButton({
			text: 'Cancel',
			handler: data => {
        this.paymentData.PAYMENT_TYPE_ID = '';      //cancel to clear data
        this.paymentData.PAYMENT_SUB_TYPE_ID = '';
			}
		});
		alertPaymentSubType.addButton({
			text: 'OK',
			handler: data => {
        if (data == null){
          this.popPaymentSubType(authorizeVal);
          this.presentToast('Please select Payment Type.')
        }
        else {
          this.RadioOpen = false;
          this.RadioResult = data;
          this.paymentData.PAYMENT_SUB_TYPE_ID = this.RadioResult;
          if(authorizeVal == "YES") {
            //console.log("Sub Type: " + this.RadioResult);
            this.authorize(this.RadioResult);
          }
        }
			}
		});
		alertPaymentSubType.present();
	}
	
	authorize(paymentSubType) {
    let alert = this.alertCtrl.create({                                                         //authorization number should not be null
      title: 'Authorization Number',
      inputs: [
        {
          name: 'Auth_No',
          placeholder: 'Authorization Number',
          type: 'text'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            //console.log('Cancel clicked');
            this.paymentData.PAYMENT_TYPE_ID = '';      //cancel to clear data
            this.paymentData.PAYMENT_SUB_TYPE_ID = '';
            this.paymentData.AUTH_NO = "";
          }
        },
        {
          text: 'Enter',
          handler: data => {
            //this.paymentData.PAYMENT_TYPE_ID = '2';
            //this.paymentData.PAYMENT_SUB_TYPE_ID = paymentSubType;
            if (data.Auth_No == ''){
              this.authorize(paymentSubType)
              this.presentToast('Please enter Authorization Number.')
            }
            else {
              this.paymentData.AUTH_NO = data.Auth_No;
            }
          }
        }
      ]
    });
    alert.present();
    
/*     if (this.paymentData.PAYMENT_TYPE_ID == '4' || this.paymentData.PAYMENT_TYPE_ID == '2'){         //For bank payment, authorization number should not be null
      let alert = this.alertCtrl.create({                                                            //add credit card
        title: 'Authorization Number',
        inputs: [
          {
            name: 'Auth_No',
            placeholder: 'Authorization Number',
            type: 'text'
          }
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: data => {
              //console.log('Cancel clicked');
              this.paymentData.PAYMENT_TYPE_ID = '';      //cancel to clear data
              this.paymentData.PAYMENT_SUB_TYPE_ID = '';
              this.paymentData.AUTH_NO = "";
            }
          },
          {
            text: 'Enter',
            handler: data => {
              //this.paymentData.PAYMENT_TYPE_ID = '2';
              //this.paymentData.PAYMENT_SUB_TYPE_ID = paymentSubType;
              if (data.Auth_No == ''){
                this.authorize(paymentSubType)
                this.presentToast('Please enter Authorization Number.')
              }
              else {
                this.paymentData.AUTH_NO = data.Auth_No;
              }
            }
          }
        ]
      });
      alert.present();
    }
    else {
      let alert = this.alertCtrl.create({
        title: 'Authorization Number',
        inputs: [
          {
            name: 'Auth_No',
            placeholder: 'Authorization Number',
            type: 'text'
          }
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: data => {
              //console.log('Cancel clicked');
              this.paymentData.PAYMENT_TYPE_ID = '';      //cancel to clear data
              this.paymentData.PAYMENT_SUB_TYPE_ID = '';
              this.paymentData.AUTH_NO = "";
            }
          },
          {
            text: 'Enter',
            handler: data => {
              //this.paymentData.PAYMENT_TYPE_ID = '2';
              //this.paymentData.PAYMENT_SUB_TYPE_ID = paymentSubType;
              this.paymentData.AUTH_NO = data.Auth_No;
            }
          }
        ]
      });
      alert.present();
    } */
	}

  payFleetCard(){
    this.errorMessage = '';
    this.overlayHidden = false;
  }

  pay(){
    //this.f_fleetPay = 0;
    if (this.paymentData.PAYMENT_TYPE_ID != ''){
      if ((this.single_payment != 0) && (this.single_payment != null)){

        if (this.paymentData.PAYMENT_TYPE_ID == '3'){                                  //fleet card
          if (this.cardData.CARD_NO == ''){
            this.errorAlert("No fleet card data.");
          }
          else if (this.single_payment > parseFloat(this.cardData.BALANCE)){           //pay over card balance
            this.errorAlert("Fleet card insufficient balance.");
          } 
          else if (this.cardData.CARD_ACTIVE != 'YES'){
            this.errorAlert("Fleet card not active.");
          }
          else {

            this.paymentData.PAYMENT_TYPE_ID = this.paymentData.PAYMENT_TYPE_ID;
            this.paymentData.PAYMENT_SUB_TYPE_ID = this.paymentData.PAYMENT_SUB_TYPE_ID;
            this.paymentData.AMOUNT_TENDER = this.single_payment;
            this.paymentData.AUTH_NO = this.paymentData.AUTH_NO;
            this.paymentData.CORP_CARD_NO = this.cardData.CARD_NO;
            this.paymentData.CORP_NAME = this.cardData.CORP_NAME;
            this.myDate = this.formatDateTime();
            this.paymentData.DATETIME = this.myDate;

            //if (this.servicegvariable.InternetConnection == 'Online'){
              //this.cardData.BALANCE = (+this.cardData.BALANCE - +this.single_payment).toString();
              //this.PAYMENT_JSON(this.paymentData);          //disable online payment 210320
            //}
            //else {                                            //offline
                /*this.storage.get('cardData').then((data) => {   //to solve balance deduct before actual payment success
                this.tempcardData = data;
                if (data && data.length > 0) {
                  for (let i=0; i<data.length; i++){
                      
                    let data = JSON.parse(this.tempcardData[i]);
                    for (let i=0; i<data.length; i++){
                      if (this.cardData.CARD_NO == data[i].CARD_NO){
                        data[i].BALANCE = +data[i].BALANCE - +this.single_payment;  
                        this.cardData.BALANCE = data[i].BALANCE;
                      }
                    }
                    let val = JSON.stringify(data);
                    let array = [];
                    array.push(val);
                    this.storage.set('cardData', array);                //store group access arr
                    this.PAYMENT_JSON(this.paymentData);
                  }
                }
              });*/
              this.PAYMENT_JSON(this.paymentData);

            //}
          }
          //this.paymentData.AUTH_NO = "";
        }
        // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
        else if(this.paymentData.PAYMENT_TYPE_ID == '7') {
          this.wantokPaymentData.CardNo = this.wantokGiftCardNo;
          this.wantokPaymentData.CardPin = this.wantokGiftCardPin;
          this.wantokPaymentData.Amount = this.single_payment;

          let wantokPayLength = this.PAYMENT_Array.length;
          for(let i=0; i<wantokPayLength; i++) {
            if(this.PAYMENT_Array[i].PAYMENT_TYPE_ID == '7' && this.PAYMENT_Array[i].AUTH_NO == this.wantokPaymentData.CardNo) {
              this.wantokPaymentData.Amount += this.PAYMENT_Array[i].AMOUNT_TENDER;
            }
          }

          this.showLoader();
          this.serviceapi.validateWantokPayment(this.wantokPaymentData).then((result) => {
            this.Status = result['responseCode'];
            if (this.Status == 'SUCCESS') {
              this.loading.dismiss();

              this.paymentData.PAYMENT_TYPE_ID = this.paymentData.PAYMENT_TYPE_ID;
              this.paymentData.PAYMENT_SUB_TYPE_ID = this.paymentData.PAYMENT_SUB_TYPE_ID;
              this.paymentData.AMOUNT_TENDER = this.single_payment;
              this.paymentData.WANTOK_GIFT_CARD = this.wantokPaymentData.CardNo;
              this.myDate = this.formatDateTime();
              this.paymentData.DATETIME = this.myDate;
              this.PAYMENT_JSON(this.paymentData);
            }
            else {
              this.loading.dismiss();
              this.wantokPaymentData.Amount -= this.single_payment;
              this.errorMessage = result['Message'];
            }
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();
          });
        }
        // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
        else {                                                    //other than fleet card
          this.paymentData.PAYMENT_TYPE_ID = this.paymentData.PAYMENT_TYPE_ID;
          this.paymentData.PAYMENT_SUB_TYPE_ID = this.paymentData.PAYMENT_SUB_TYPE_ID;
          this.paymentData.AMOUNT_TENDER = this.single_payment;
          this.paymentData.AUTH_NO = this.paymentData.AUTH_NO;
          this.paymentData.CORP_CARD_NO = this.cardData.CARD_NO;
          this.myDate = this.formatDateTime();
          this.paymentData.DATETIME = this.myDate;

          this.PAYMENT_JSON(this.paymentData);
          //this.paymentData.AUTH_NO = "";
        }
      }
      else {
        this.errorAlert("Please enter payment amount");
      }
    }
    else {
      this.errorAlert("Please select payment");
    }
  }

  formatDateTime(){
    let date = new Date();
    let sign1 = "-";
    let sign2 = ":";
    let year:any = date.getFullYear() // 年
    let month:any = date.getMonth() + 1; // 月
    let day:any  = date.getDate(); // 日
    let hour:any = date.getHours(); // 时
    let minutes:any = date.getMinutes(); // 分
    let seconds:any = date.getSeconds() //秒

    // 给一位数数据前面加 “0”
    if ((month >= 1) && (month <= 9)) {
      month = '0' + month;
    }
    if ((day >= 0) && (day <= 9)) {
      day = '0' + day;
    }
    if ((hour >= 0) && (hour <= 9)) {
      hour = '0' + hour;
    }
    if ((minutes >= 0) && (minutes <= 9)) {
      minutes = '0' + minutes;
    }
    if ((seconds >= 0) && (seconds <= 9)) {
      seconds = '0' + seconds;
    }
    var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds;
    return currentdate;
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
  SoDateTime(){
    let date = new Date();
    let year:any = date.getFullYear().toString().substr(-2) // 年
    let month:any = date.getMonth() + 1; // 月
    let day:any  = date.getDate(); // 日
    let hour:any = date.getHours(); // 时
    let minutes:any = date.getMinutes(); // 分
    let seconds:any = date.getSeconds() //秒

    // 给一位数数据前面加 “0”
    if ((month >= 1) && (month <= 9)) {
      month = '0' + month;
    }
    if ((day >= 0) && (day <= 9)) {
      day = '0' + day;
    }
    if ((hour >= 0) && (hour <= 9)) {
      hour = '0' + hour;
    }
    if ((minutes >= 0) && (minutes <= 9)) {
      minutes = '0' + minutes;
    }
    if ((seconds >= 0) && (seconds <= 9)) {
      seconds = '0' + seconds;
    }
    var currentdate = year + month + day + hour + minutes + seconds;
    return currentdate;
  }

  errorAlert(message){
    let errorAlert = this.alertCtrl.create({
      title:"ERROR",
      message:message,
      buttons:[
        {
          text:"OK"
        }]
    });
    errorAlert.present();
  }

  checkout(){
    if (this.paymentBalance != 0){
      this.errorAlert("Payment balance not clear.");
    }
    else {
      //Change to upload Fleet card SO every 10min
      this.offlineCheckOut();

      /* if (this.servicegvariable.InternetConnection == 'Online'){
        //load dummy to check internet connection 
        let tbl = ["INVENTORY"];
        let column = ["INVENTORY_ID"];
        let value = ["1"];

        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.showonlineLoader();
        this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
          this.loading.dismiss();

          this.DATA_JSON(this.userId, '1', this.wantokCard, this.userBranchId, this.SOL_Array, this.PAYMENT_Array);

          let value = this.SUBMIT_JSON(this.userId,this.DATA_Array);
          console.log(value);
          this.showLoader();
          this.serviceapi.possalesdata(value).then((result) => {
            this.Status = result["Message"];
            console.log(this.Status);
            if (this.Status == "1"){  
              let temp_run = result["SO_NO"];
              this.SO_NO = temp_run;                            //get SO number from last transaction
              console.log(this.SO_NO);

              if (this.salesParam == '2'){                      //if sales from layby
                this.serviceapi.deletedata('SO2', 'SO_ID', this.Layby_SO_ID).then((result) => {       //delete SO2
              
                  this.Status = result["Message"];
                  if (this.Status == "1"){

                    this.serviceapi.deletedata('SOL2', 'SO_ID', this.Layby_SO_ID).then((result) => {  //delete SOL2
              
                      this.Status = result["Message"];
                      if (this.Status == "1"){
                        
                      }
                      else {
                        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      }
                    }, (err) => {
                    });
                  }
                  else {
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  }
                }, (err) => {
                });
              }

              this.storage.get('closingData').then((data) => {
                let val = "";
                let count = 0;

                for(count = 0;count <this.DATA_Array.length;count++)
                {
                  val = this.DATA_Array[count];
                  if(data != null)
                  {
                      data.push(val);
                      this.storage.set('closingData', data);
                  }
                  else
                  {
                    let array = [];
                    array.push(val);
                    this.storage.set('closingData', array);
                  }
                }
              });

              this.userRunNo = 0;
              let val2 = JSON.stringify(this.userRunNo);
              this.storage.set('runningNoData', val2);

              let val3 = JSON.stringify(this.SO_NO);
              this.storage.set('lastSO_NO', val3);

              let val = JSON.stringify(this.DATA_Array);
              let array2 = [];
              array2.push(val);
              this.storage.set('lastSalesData', array2);          //store last sales for re-print function

              this.loading.dismiss();
              this.printReceipt();
            }
            else{
//              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
              this.loading.dismiss();
              let confirm = this.alertCtrl.create({
                title: 'Loading Error',
                message: this.serviceapi.displayErrorMessage(this.Status),
                buttons: [
                  {
                    text: 'Confirm',
                    handler: () => {
                    console.log('Agree clicked');
//                      this.navCtrl.setRoot(B01SalesPage);       //s31 gary: bar due to site complaint
                                                                  //loading then goes back to sales page without goes to printing
                    }
                  }
                ]
              });
              confirm.present();
            }
          }, (err) => {
//            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();

            let confirm = this.alertCtrl.create({
              title: 'Loading Error',
              message: 'Please try again.',
              buttons: [
                {
                  text: 'Confirm',
                  handler: () => {
                  console.log('Agree clicked');
//                    this.navCtrl.setRoot(B01SalesPage);           //go back to sales page without do anything
                                                                  //s31 gary: bar due to site complaint
                                                                  //loading then goes back to sales page without goes to printing
                  }
                }
              ]
            });
            confirm.present();
          });
        }, (err) => {
          console.log("online offline")
          this.loading.dismiss();
          
          if (this.servicegvariable.InternetConnection == 'Online'){
            this.servicegvariable.InternetConnection = 'Offline';
            let confirm = this.alertCtrl.create({
              title: 'Offline',
              message: 'No internet connection. Transaction will store at local device until internet connection again.',
              buttons: [
                {
                  text: 'Confirm',
                  handler: () => {
                  console.log('Agree clicked');
                    this.offlineCheckOut();
                  }
                }
              ]
            });
            confirm.present();
          }  
        });
      }
      else{                                                                         //no internet, store local
        this.offlineCheckOut();
      }  */
    }
  }

  offlineCheckOut(){
    this.DATA_JSON(this.userId, '1', this.wantokCard, this.userBranchId, this.SOL_Array, this.PAYMENT_Array);

      //let val = JSON.stringify(this.DATA_Array); // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      /*this.storage.get('localData').then((data) => {
        if(data != null)
        {
          data.push(val);
          this.storage.set('localData', data);
        }
        else
        {
          let array = [];
          array.push(val);
          this.storage.set('localData', array);
        }
        console.log(data);
      }); */

    //  [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    /*if (this.f_fleetPay==1) {
      //this.f_fleetPay=0;
      this.storage.get('localData2').then((data) => {
        let val2 = "";
        let count = 0;

        for(count = 0;count <this.DATA_Array.length;count++)
        {
          val2 = this.DATA_Array[count];
          if(data != null)
          {
              data.push(val2);
              this.storage.set('localData2', data);
          }
          else
          {
            let array = [];
            array.push(val2);
            this.storage.set('localData2', array);
          }
        }
      });
    }*/

    //  [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    /*let array2 = [];
    array2.push(val);
    this.storage.set('lastSalesData', array2);*/          //store last sales for re-print function

    this.userId = sessionStorage.getItem('userid');     //user ID

    this.storage.get('userData').then((data) => {
      this.userData = data;
      console.log(data);
      if (data && data.length > 0) {
        for (let i=0; i<data.length; i++){
            
          let data = JSON.parse(this.userData[i]);
          console.log(data);
          for (let i=0; i<data.length; i++){
            if (this.userId == data[i].USER_ID){
              /* data[i].USER_RUNNO = this.userRunNo; */
              console.log(data[i].USER_RUNNO);
            }
          }
          let val = JSON.stringify(data);
          let array = [];
          array.push(val);
          console.log(array);
          this.storage.set('userData', array);                //store group access arr
        }
      }
    });

    //  [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    /*this.storage.get('closingData').then((data) => {
      let val2 = "";
      let count = 0;

      for(count = 0;count <this.DATA_Array.length;count++)
      {
        val2 = this.DATA_Array[count];
        if(data != null)
        {
            data.push(val2);
            this.storage.set('closingData', data);
        }
        else
        {
          let array = [];
          array.push(val2);
          this.storage.set('closingData', array);
        }
      }
    });*/

    //check and deduct inventory level
/*     let length1 = this.SOL_Array.length;
    for (let x=0; x<length1; x++ ) { */

      this.storage.get('inventoryLevelData').then((data) => {
        this.tempLevelData = data;            
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.tempLevelData[i]);
            let length1 = this.SOL_Array.length;
            for (let x=0; x<length1; x++ ) {
              for (let i=0; i<data.length; i++){
                if (this.SOL_Array[x].INVENTORY_ID == data[i].INVENTORY_ID){
                  console.log(data[i])
                  data[i].QUANTITY = +data[i].QUANTITY - +this.SOL_Array[x].QTY;  
                  console.log(data[i].QUANTITY)
                }
              }
            }
            let val = JSON.stringify(data);
            let array = [];
            array.push(val);
            this.storage.set('inventoryLevelData', array);                //store group access arr
          }
        }
      });
    //}

    // [CXY:14/06/2020:CR/MPOS/20-01]:Change if else sequence
    // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    // pay with fleet card
    /*if(this.f_fleetPay == 1) {
      this.storage.get('runningNoData2').then((data) => {          //load runningNo
        if (data && data.length > 0) {
          this.userRunNo = data;
          console.log(this.userRunNo);
        }
        else {
          this.userRunNo = 0;
        }

        this.userRunNo = +this.userRunNo + 1;                  //offline add 1 
        console.log(this.userRunNo);
        let val4 = JSON.stringify(this.userRunNo);
        this.storage.set('runningNoData2', val4);                //save
        this.storage.set('lastSaleRunningNo', val4);

        this.storage.get('lastSO_NO2').then((data) => {          //load last SO_NO
          console.log(data);
          if (data && data.length > 0) {
            this.SO_NO = data;
            console.log(this.SO_NO);
          }
          else {
            let temp = "No last SO";
            this.SO_NO = temp;
          }
          //this.servicegvariable.f_lastfleetPay = 1;
          this.storage.set('lastSaleSO_NO', this.SO_NO);
          this.storage.set('lastSale_fleet', 1);
          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          if(this.f_wantokPay == 1) {
            this.storage.set('lastSale_wantokGC', 1);
            this.payWantokGiftCard();
          }
          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          this.printReceipt();
        });
      });
    }
    // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
    //pay with Wantok Gift Card
    else if(this.f_wantokPay == 1) {
      this.checkInternet(); // Check Internet Connection

      if (this.servicegvariable.InternetConnection == 'Online') {
        this.storage.get('runningNoData3').then((data) => {
          if (data && data.length > 0) {
            this.userRunNo = data;
          }
          else {
            this.userRunNo = 0;
          }
  
          this.userRunNo = +this.userRunNo + 1;
          let val4 = JSON.stringify(this.userRunNo);
          this.storage.set('runningNoData3', val4);
          this.storage.set('lastSaleRunningNo', val4);
          
          this.storage.get('lastSO_NO3').then((data) => {
            if (data && data.length > 0) {
              this.SO_NO = data;
            }
            else {
              let temp = "No last SO";
              this.SO_NO = temp;
            }
            this.storage.set('lastSaleSO_NO', this.SO_NO);
            this.storage.set('lastSale_fleet', 0);
            this.storage.set('lastSale_wantokGC', 1);
            this.payWantokGiftCard();
            this.printReceipt();
          });
        });
      }
      else {
        this.errorAlert("Internet Offline. Cannot checkout sales with Wantok Gift Card");
      }
    }
    // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
    // pay with other payment method
    else {
      this.storage.get('runningNoData').then((data) => {          //load runningNo
        if (data && data.length > 0) {
          this.userRunNo = data;
          console.log("userRunNo: " + this.userRunNo);
        }
        else {
          this.userRunNo = 0;
        }

        this.userRunNo = +this.userRunNo + 1;                  //offline add 1 
        console.log(this.userRunNo);
        let val4 = JSON.stringify(this.userRunNo);
        this.storage.set('runningNoData', val4);                //save
        this.storage.set('lastSaleRunningNo', val4);
        
        this.storage.get('lastSO_NO').then((data) => {          //load last SO_NO
          console.log(data);
          if (data && data.length > 0) {
            this.SO_NO = data;
            console.log("SO_NO: " + this.SO_NO);
          }
          else {
            let temp = "No last SO";
            this.SO_NO = temp;
          }
          //this.servicegvariable.f_lastfleetPay = 0;
          this.storage.set('lastSaleSO_NO', this.SO_NO);
          this.storage.set('lastSale_fleet', 0);
          this.storage.set('lastSale_wantokGC', 0);  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
          this.printReceipt();
        });
      });
    }*/
  }

  printReceipt(){
    let length1 = this.SOL_Array.length;
    let total = 0;
    let total_tax = 0;
    let grand_total = 0;
    for (let i=0; i<length1; i++ ) {
      total = +total+ +this.SOL_Array[i].SOL_TOTAL;
      total_tax = +total_tax+ +this.SOL_Array[i].TOTAL_TAX;
      grand_total = +grand_total+ +this.SOL_Array[i].GRAND_SOL_TOTAL;
    }
    
    // this.LOCAL_SO_ID = this.SO_NO; // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    
/*     if (this.LOCAL_SO_ID.length == '18') {
      var last10 = this.LOCAL_SO_ID.slice(-11);   //"S0025A 0000033667
      var firstID = this.LOCAL_SO_ID.substring(0, 7);
      var runingNo = +parseFloat(last10) + this.userRunNo;
      var runingNo10 = this.pad_with_zeroes(runingNo , 10);
      console.log(this.LOCAL_SO_ID.length, firstID, last10, runingNo10);
      this.LOCAL_SO_ID = firstID + runingNo10;
      console.log(this.LOCAL_SO_ID);
    }
    else  */
    //if (this.LOCAL_SO_ID.toString().length == '19'){
    
    // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    /*if (this.f_fleetPay == 1){
      var last10 = this.LOCAL_SO_ID.slice(-11);   //"CS0025A 0000033667
      var firstID = this.LOCAL_SO_ID.substring(0, 8);
      var runingNo = +parseFloat(last10) + this.userRunNo;
      var runingNo10 = this.pad_with_zeroes(runingNo , 10);
      console.log(this.LOCAL_SO_ID.toString().length, firstID, last10, runingNo10);
      this.LOCAL_SO_ID = firstID + runingNo10;
      console.log(this.LOCAL_SO_ID);
    }*/

    if(this.plt.is("core"))
    {
      //console.log("web")
      let company = this.companyData.COMPANY;
      let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
      let contact = this.companyData.CONTACT_NO1 
      let email = this.companyData.EMAIL;
      let date = this.formatDateTime();
      let username = this.userName;
      
      //let total = this.TOTAL;
      //let total_tax = this.TOTAL_TAX;
      //let grand_total = this.SO.GRAND_TOTAL;
      var mywindow = window.open('', 'RECEIPT', 'height=400,width=600');
      mywindow.document.write('<html><head><title></title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<div style="max-width: 500px;margin: auto;text-align:center">');

      mywindow.document.write('<b>'+company+'</b><br>');
      mywindow.document.write(address+'<br>');
      mywindow.document.write('Phone: '+contact+'<br>');
      mywindow.document.write('Email: '+email+'<br>');
      mywindow.document.write('<br><b>'+'RECEIPT'+'</b><br>');
      mywindow.document.write('<br>Username: '+username+'<br>');
      mywindow.document.write('Date: '+date+'<br>');

      // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      /*if(this.userRunNo == 0){
        mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID+'<br>');
      }
      else {
        console.log(this.f_fleetPay)
        if (this.f_fleetPay == 1){
          console.log('this.LOCAL_SO_ID.length')
          mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID +'<br>');
        }
        else {
          mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID + ' + ' + this.userRunNo+'<br>');
        }
      }*/
      mywindow.document.write('Receipt Number: '+this.DATETIME_SO +'<br>'); // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Change to DateTimeSO)

      mywindow.document.write('<table>');
      mywindow.document.write('<tr><td style="width:250px;text-align:left">'+'Item' + '</td><td style="width:100px;text-align:right">' +'Price'+ '</td><td style="width:100px;text-align:right">'+'Quantity' + '</td><td style="width:100px;text-align:right">' + 'Subtotal' + '</td></tr>');
      let length1 = this.SOL_Array.length;
      for (let i=0; i<length1; i++ ) {
        mywindow.document.write('<tr><td style="width:250px">'+this.SOL_Array[i].SOL_DESC + '</td><td style="width:100px;text-align:right">'+this.SOL_Array[i].UNIT_PRICE + '</td><td style="width:100px;text-align:right">'+this.SOL_Array[i].QTY + '</td><td style="width:100px;text-align:right"> K' + parseFloat(this.SOL_Array[i].SOL_TOTAL).toFixed(2) + '</td></tr>');
      }
      mywindow.document.write('<br><br>');
      
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Subtotal</td><td style="width:100px; text-align:right"> K' +parseFloat(total.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Tax</td><td style="width:100px; text-align:right"> K' +parseFloat(total_tax.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Total</td><td style="width:100px; text-align:right"> K' +parseFloat(grand_total.toString()).toFixed(2)+'</td></tr></table>');
      //mywindow.document.write('Card No : '+this.translistData.CardNo+'<br>Date    : '+arr[0]+'<br>Time    : '+arr[1]+'<br>Trans ID : '+this.transid+'<br>Amount  : K '+ this.translistData.Amount+'<br>Sold By : '+ this.translistData.UserName);
      mywindow.document.write('<br>'+'---------------------------------------------'+'<br><br>');
      
      mywindow.document.write('<table>');
      let length2 = this.PAYMENT_Array.length;
      for (let i=0; i<length2; i++ ) {
        let lengthPay = this.paymentTypeArr.length;
        for (let j=0; j< lengthPay; j++){
          if (this.PAYMENT_Array[i].PAYMENT_TYPE_ID == this.paymentTypeArr[j].PAYMENT_TYPE_ID){
            this.PAYMENT_Array[i].TYPE = this.paymentTypeArr[j].TYPE;
          }
        }
        if (this.PAYMENT_Array[i].PAYMENT_TYPE_ID != '3'){
          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          if(this.PAYMENT_Array[i].PAYMENT_TYPE_ID == '7') {
            mywindow.document.write('<tr><td style="width:350px">' + this.PAYMENT_Array[i].TYPE + ':' + this.PAYMENT_Array[i].WANTOK_GIFT_CARD + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
          }
          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          else
            mywindow.document.write('<tr><td style="width:350px">'+this.PAYMENT_Array[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
        }
        else{
          mywindow.document.write('<tr><td style="width:350px">'+this.PAYMENT_Array[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Card No.: ' +this.PAYMENT_Array[i].CORP_CARD_NO + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Company: ' +this.PAYMENT_Array[i].CORP_NAME + '</td></tr>');
        }

        if (this.PAYMENT_Array[i].AMOUNT_CHANGE > 0){
          mywindow.document.write('<tr><td style="width:350px">'+'Change' + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array[i].AMOUNT_CHANGE).toFixed(2) + '</td></tr>');
        }
      }
      if (this.wantokCard != ''){
        mywindow.document.write('<tr><td style="width:350px">'+ 'Wantok Card: ' +this.wantokCard + '</td></tr>');
      }

      mywindow.document.write('</table><br><br><b>------ PLEASE COME AGAIN ------</b><br>');
      mywindow.document.write('<div></body></html>'); 

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus();
      mywindow.print();
      mywindow.close();
      this.navCtrl.setRoot(B01SalesPage);
    }
    else
    {
      this.companyInfo = '';
      this.userInfo = '';
      this.receiptInfo = '';
      this.receiptInfo2 = '';
      this.paymentInfo = '';
      this.paymentInfo2 = '';
      this.thankyouInfo = '';
      // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_companyInfo = '';
      this.s_userInfo = '';
      this.s_receiptInfo = '';
      this.s_receiptInfo2 = '';
      this.s_paymentInfo = '';
      this.s_paymentInfo2 = '';
      this.s_thankyouInfo = '';
      // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added

      let company = this.companyData.COMPANY;
      let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
      let contact = this.companyData.CONTACT_NO1 
      let email = this.companyData.EMAIL;
      let date = this.formatDateTime();
      let username = this.userName;

      //let total = this.TOTAL;
      //let total_tax = this.TOTAL_TAX;
      //let grand_total = this.GRAND_TOTAL;
    
      //header
      /*
      '\x1b\x61\x01'    center
      '\n'              end of line
      '\x1b\x45\x00'    Bold font OFF
      '\x1b\x45\x01'    Bold font ON
      '\x1b\x4d\x00'    Font type A //normal font
      '\x1b\x4d\x01'    Font type B //small font
      '\x1b\x4d\x02'    Font type C //big font
      '\x1b\x61\x00'    Left justification
      '\x1b\x61\x01'    Centering
      '\x1b\x61\x02'    Right justification
      */

      //print branch info
      this.companyInfo = "\x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n"+
                          "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
      // [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_companyInfo = "\x1b\x4d\x01 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n"+
                          "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";

      // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      /*if(this.userRunNo == 0){
        this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
        // [CXY:01/06/2020:CR/MPOS/20-02]:Added
        this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
      }   
      else {
        if (this.f_fleetPay == 1){
          this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
          // [CXY:01/06/2020:CR/MPOS/20-02]:Added
          this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
        }
        else {
          this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+'+'+this.userRunNo+"\n\n";
          // [CXY:01/06/2020:CR/MPOS/20-02]:Added
          this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+'+'+this.userRunNo+"\n\n";
        }
      }*/
      // [CXY:17/08/2020:IL/MPOS/20-07]: Modify font size
      this.userInfo += '\x1b\x4d\x01' + 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.DATETIME_SO+"\n\n";  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
      this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.DATETIME_SO+"\n\n"; // [CXY:10/08/2020:CR/MPOS/20-03]:Added
      this.userInfo += '\x1b\x4d\x00' + '\x1b\x44\x00' + '\x1b\x44\x10\x18\x22\x25\x00'        //set tab position at 32

      //print SOL
      this.userInfo += '\x1b\x61\x00' + ' ' + 'Item' + '\x09' + 'Price'+ '\x09' + 'Quantity' + '\x09' + '\x09' + 'Subtotal' + "\n";
      // [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_userInfo += '\x1b\x61\x00' + ' ' + 'Item' + '   ' + 'Price' + '\x09' + 'Quantity' + ' \x09' + 'Subtotal' + "\n";

      let length1 = this.SOL_Array.length;
      for (let i=0; i<length1; i++ ) {
        if (this.receiptInfo.length < 100) {
          this.receiptInfo += ' ' + this.SOL_Array[i].SOL_DESC + '\x09' + this.SOL_Array[i].UNIT_PRICE + '\x09' + this.SOL_Array[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.SOL_Array[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:01/06/2020:CR/MPOS/20-02]:Added - not check separate for length is due to length should be almost same
          this.s_receiptInfo += ' ' + this.SOL_Array[i].SOL_DESC + ' ' + this.SOL_Array[i].UNIT_PRICE + ' \x09' + this.SOL_Array[i].QTY + '\x09' + "K" + parseFloat(this.SOL_Array[i].SOL_TOTAL).toFixed(2) + "\n";
        }
        else {
          this.receiptInfo2 += ' ' + this.SOL_Array[i].SOL_DESC + '\x09' + this.SOL_Array[i].UNIT_PRICE + '\x09' + this.SOL_Array[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.SOL_Array[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:01/06/2020:CR/MPOS/20-02]:Added
          this.s_receiptInfo2 += ' ' + this.SOL_Array[i].SOL_DESC + ' ' + this.SOL_Array[i].UNIT_PRICE + ' \x09' + this.SOL_Array[i].QTY + '\x09' + "K" + parseFloat(this.SOL_Array[i].SOL_TOTAL).toFixed(2) + "\n";
        }
      }
      this.receiptInfo2 +=   "\n" + " Subtotal:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total.toString()).toFixed(2) + "\n" +
                            " Tax:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total_tax.toString()).toFixed(2) + "\n" +
                            " Total:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(grand_total.toString()).toFixed(2) + "\n";
      // [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_receiptInfo2 +=  "\n \x09\x09" + "Subtotal" + ' \x09' + " K" + parseFloat(total.toString()).toFixed(2) + "\n" +
                            "\x09\x09" + "     Tax" + ' \x09' +  " K" + parseFloat(total_tax.toString()).toFixed(2) + "\n" +
                            "\x09\x09" + "   Total" + ' \x09' + " K" + parseFloat(grand_total.toString()).toFixed(2) + "\n";

      this.receiptInfo2 +=   '\x1b\x61\x01' + "\n"+'--------------------'+"\n";
      // [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_receiptInfo2 +=   '\x1b\x61\x01' + "\n"+'--------------------'+"\n";

      this.paymentInfo += '\x1b\x44\x00' + '\x1b\x44\x22\x25\x00';        //set tab position at 32
      //print payment
      let length2 = this.PAYMENT_Array.length;
      for (let i=0; i<length2; i++ ) {
        let lengthPay = this.paymentTypeArr.length;
        for (let j=0; j< lengthPay; j++){
          if (this.PAYMENT_Array[i].PAYMENT_TYPE_ID == this.paymentTypeArr[j].PAYMENT_TYPE_ID){
            this.PAYMENT_Array[i].TYPE = this.paymentTypeArr[j].TYPE;
          }
        }
        if (this.PAYMENT_Array[i].PAYMENT_TYPE_ID != '3'){
          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          if(this.PAYMENT_Array[i].PAYMENT_TYPE_ID == '7') {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n"; // [CXY:01/06/2020:CR/MPOS/20-02]:Added
              this.s_paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n"; // [CXY:01/06/2020:CR/MPOS/20-02]:Added
              this.s_paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
            }
          }
          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          else {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:01/06/2020:CR/MPOS/20-02]:Added
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:01/06/2020:CR/MPOS/20-02]:Added
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
          }
        }
        else {
          if (this.paymentInfo.length < 90) {
            this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].CORP_CARD_NO + "\n";
            this.paymentInfo += ' ' + 'Company: '+ this.PAYMENT_Array[i].CORP_NAME + "\n";
            // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
            this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo += ' ' + 'Company: '+ this.PAYMENT_Array[i].CORP_NAME + "\n";
            // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added
          }
          else{
            this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].CORP_CARD_NO + "\n";
            this.paymentInfo2 += ' ' + 'Company: '+ this.PAYMENT_Array[i].CORP_NAME + "\n";
            // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
            this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo2 += ' ' + 'Company: '+ this.PAYMENT_Array[i].CORP_NAME + "\n";
            // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added
          }
        } 

        if (this.PAYMENT_Array[i].AMOUNT_CHANGE > 0){
          this.thankyouInfo += ' ' + 'Change' + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array[i].AMOUNT_CHANGE).toFixed(2) + "\n";
          // [CXY:01/06/2020:CR/MPOS/20-02]:Added
          this.s_thankyouInfo += ' ' + 'Change' + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array[i].AMOUNT_CHANGE).toFixed(2) + "\n";
        }
      }
      if (this.wantokCard != ''){
        this.thankyouInfo += ' ' + 'Wantok Card: ' + this.wantokCard + "\n";
        // [CXY:01/06/2020:CR/MPOS/20-02]:Added
        this.s_thankyouInfo += ' \x1b\x61\x00' + 'Wantok Card: ' + this.wantokCard + "\n";
      }
      this.thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n\n\n\n\n\n\n\n\n\n";
      // [CXY:01/06/2020:CR/MPOS/20-02]:Added
      this.s_thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n";

      //console.log(this.receiptInfo.length, this.receiptInfo2.length)
      //console.log(this.paymentInfo.length, this.paymentInfo2.length)
      this.navCtrl.setRoot(B08PrinterPage,{
        param1: this.companyInfo,
        param2: "1",
        param3: this.userInfo,
        param4: this.receiptInfo,
        param5: this.receiptInfo2,
        param6: this.paymentInfo,
        param7: this.paymentInfo2,
        param8: this.thankyouInfo,
        // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
        param9: this.s_companyInfo,
        param10: this.s_userInfo,
        param11: this.s_receiptInfo,
        param12: this.s_receiptInfo2,
        param13: this.s_paymentInfo,
        param14: this.s_paymentInfo2,
        param15: this.s_thankyouInfo,
        // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added
      });
    }
  }

  checkPaymentType(){
    
   
  }

  SUBMIT_JSON(USERID, DATA)
  {
    let COMPILE_DATA = {
      Param:"",
      UserID: "",
      Total:0,
      CRC:"",
      Data:[]
    }

//    COMPILE_DATA.Param = "1";                         //Param 1
    COMPILE_DATA.Param = "1";                         //Param 4 = upload with checksum
    COMPILE_DATA.UserID = USERID;
    COMPILE_DATA.Total =  (this.DATA_Array).length;
    COMPILE_DATA.Data = DATA;

/*     let val = JSON.stringify(DATA);
    console.log(val);
    COMPILE_DATA.CRC = crc32(val); */

    return COMPILE_DATA;
  }

  SOL_JSON(SALES)
  {
      let SOL = {	
        SOL_DESC:"",
        QTY:"",
        UNIT_PRICE:"0",
        DISC_PERC:"0",
        TAX_PERC:"0",
        TOTAL_TAX:"0",
        SOL_TOTAL:"0",
        GRAND_SOL_TOTAL:"0",
        INVENTORY_ID:""
      }

      SOL.SOL_DESC = SALES.description;
      SOL.QTY = SALES.quantity;
      SOL.UNIT_PRICE = SALES.each;
      SOL.DISC_PERC = SALES.discount_perc;
      SOL.TAX_PERC = SALES.tax_perc;
      SOL.TOTAL_TAX = SALES.total_tax;
      SOL.SOL_TOTAL = SALES.total_sub;
      SOL.GRAND_SOL_TOTAL = SALES.sol_total_price;
      SOL.INVENTORY_ID = SALES.ID;

      this.SOL_Array.push(SOL)
  }

  PAYMENT_JSON(PAYMENT_LINE)
  {
      let PAYMENT = {
        AMOUNT_TENDER:0,
        AMOUNT_CHANGE:0,
        CORP_CARD_NO:"0",
        AUTH_NO:"0",
        DATETIME:"",
        PAYMENT_TYPE_ID:"",
        PAYMENT_SUB_TYPE_ID:"",
        CARD_CORP:"",
        CORP_NAME:"",
        WANTOK_GIFT_CARD:"" // [CXY:14/06/2020:CR/MPOS/20-01]:Added
      }
      
      this.total_payment = +this.total_payment + parseFloat(PAYMENT_LINE.AMOUNT_TENDER);
      //console.log(this.total_payment);

      if (this.total_payment > this.total_charge_amount){                       //if pay more than total

        if (this.paymentData.PAYMENT_TYPE_ID != '1'){                           //not cash, bank card or fleet card
          if (this.paymentData.PAYMENT_TYPE_ID == '3'){                         //fleet card
            this.total_payment = +this.total_payment - parseFloat(PAYMENT_LINE.AMOUNT_TENDER);
            let alert = this.alertCtrl.create({
              title: 'Error',
              message: 'Fleet card payment amount more than balance.',
              buttons: [
                {
                  text: 'Cancel',
                  role: 'cancel',
                  handler: data => {
                    //console.log('Cancel clicked');    //no proceed
                    
                  }
                }
              ]
            });
            alert.present();
          }
          // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          else if(this.paymentData.PAYMENT_TYPE_ID == '7') {
            // pay with Wantok Gift Card
            this.total_payment =+ this.total_payment - parseFloat(PAYMENT_LINE.AMOUNT_TENDER);
            this.errorMessage = 'Wantok Gift Card payment amount more than balance.';
          }
          // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
          else {
            let alert = this.alertCtrl.create({
              title: 'Alert',
              message: 'Card or Bank payment amount more than balance. Confirm to proceed?',
              buttons: [
                {
                  text: 'Cancel',
                  role: 'cancel',
                  handler: data => {
                    //console.log('Cancel clicked');    //no proceed
                    this.total_payment = +this.total_payment - parseFloat(PAYMENT_LINE.AMOUNT_TENDER);
                  }
                },
                {
                  text: 'Enter',
                  handler: data => {
                    PAYMENT.AMOUNT_CHANGE = this.total_payment - this.total_charge_amount;  //need change
                    PAYMENT.AMOUNT_CHANGE = Number((PAYMENT.AMOUNT_CHANGE).toFixed(2));     //fix to 2 decimal places
                    this.paymentBalance = 0;

                    //continue PAYMENT_JSON
                    PAYMENT.AMOUNT_TENDER = PAYMENT_LINE.AMOUNT_TENDER;
                    PAYMENT.AMOUNT_CHANGE = PAYMENT.AMOUNT_CHANGE;
                    PAYMENT.CORP_CARD_NO = PAYMENT_LINE.CORP_CARD_NO;
                    PAYMENT.AUTH_NO = PAYMENT_LINE.AUTH_NO;
                    PAYMENT.DATETIME = PAYMENT_LINE.DATETIME;
                    PAYMENT.PAYMENT_TYPE_ID = PAYMENT_LINE.PAYMENT_TYPE_ID;
                    PAYMENT.PAYMENT_SUB_TYPE_ID = PAYMENT_LINE.PAYMENT_SUB_TYPE_ID;
                    PAYMENT.CORP_NAME = PAYMENT_LINE.CORP_NAME;
                    
                    this.PAYMENT_Array.push(PAYMENT);
                    this.single_payment = null;                           //clear input
                    this.paymentData.PAYMENT_TYPE_ID = '';
                    this.paymentData.PAYMENT_SUB_TYPE_ID = '';
                    this.paymentData.AUTH_NO = "";
                  }
                }
              ]
            });
            alert.present();
          }
        }
        else {                                                          //cash
          PAYMENT.AMOUNT_CHANGE = this.total_payment - this.total_charge_amount;  //need change
          PAYMENT.AMOUNT_CHANGE = Number((PAYMENT.AMOUNT_CHANGE).toFixed(2));     //fix to 2 decimal places
          this.paymentBalance = 0;

          //continue PAYMENT_JSON
          PAYMENT.AMOUNT_TENDER = PAYMENT_LINE.AMOUNT_TENDER;
          PAYMENT.AMOUNT_CHANGE = PAYMENT.AMOUNT_CHANGE;
          PAYMENT.CORP_CARD_NO = PAYMENT_LINE.CORP_CARD_NO;
          PAYMENT.AUTH_NO = PAYMENT_LINE.AUTH_NO;
          PAYMENT.DATETIME = PAYMENT_LINE.DATETIME;
          PAYMENT.PAYMENT_TYPE_ID = PAYMENT_LINE.PAYMENT_TYPE_ID;
          PAYMENT.PAYMENT_SUB_TYPE_ID = PAYMENT_LINE.PAYMENT_SUB_TYPE_ID;
          PAYMENT.CORP_NAME = PAYMENT_LINE.CORP_NAME;
          
          this.PAYMENT_Array.push(PAYMENT);
          this.single_payment = null;                           //clear input
          this.paymentData.PAYMENT_TYPE_ID = '';
          this.paymentData.PAYMENT_SUB_TYPE_ID = '';
          this.paymentData.AUTH_NO = "";
        }
      }
      else {                                                                     //if pay less than total
        this.paymentBalance = (this.total_charge_amount - this.total_payment).toFixed(2);    //show balance
        this.paymentData.AMOUNT_CHANGE = this.paymentBalance;

        //continue PAYMENT_JSON
        PAYMENT.AMOUNT_TENDER = PAYMENT_LINE.AMOUNT_TENDER;
        PAYMENT.AMOUNT_CHANGE = PAYMENT.AMOUNT_CHANGE;
        PAYMENT.CORP_CARD_NO = PAYMENT_LINE.CORP_CARD_NO;
        PAYMENT.AUTH_NO = PAYMENT_LINE.AUTH_NO;
        PAYMENT.DATETIME = PAYMENT_LINE.DATETIME;
        PAYMENT.PAYMENT_TYPE_ID = PAYMENT_LINE.PAYMENT_TYPE_ID;
        PAYMENT.PAYMENT_SUB_TYPE_ID = PAYMENT_LINE.PAYMENT_SUB_TYPE_ID;
        PAYMENT.CORP_NAME = PAYMENT_LINE.CORP_NAME;
        PAYMENT.WANTOK_GIFT_CARD = PAYMENT_LINE.WANTOK_GIFT_CARD; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
        
        if (this.paymentData.PAYMENT_TYPE_ID == '3'){
          this.f_fleetPay = 1;
          console.log('Fleet pay here!')
          let payment = this.single_payment;
          //deduct balance in card data
          this.storage.get('cardData').then((data) => {
            this.tempcardData = data;            
            if (data && data.length > 0) {
              for (let i=0; i<data.length; i++){
                  
                let data = JSON.parse(this.tempcardData[i]);
                for (let i=0; i<data.length; i++){
                  if (this.cardData.CARD_NO == data[i].CARD_NO){
                    data[i].BALANCE = +data[i].BALANCE - +payment;  
                    this.cardData.BALANCE = data[i].BALANCE;
                  }
                }
                let val = JSON.stringify(data);
                let array = [];
                array.push(val);
                this.storage.set('cardData', array);                //store group access arr
              }
            }
          });
        }

        // [CXY:14/06/2020:CR/MPOS/20-01]:Added
        if(this.paymentData.PAYMENT_TYPE_ID == '7') {
          // pay with Wantok Gift Card
          this.f_wantokPay = 1;
          this.wantokGiftCardNo = '';
          this.wantokGiftCardPin = '';

          this.hideOverlay_WGC();
        }

        this.PAYMENT_Array.push(PAYMENT);
        this.single_payment = null;                           //clear input
        this.paymentData.PAYMENT_TYPE_ID = '';
        this.paymentData.PAYMENT_SUB_TYPE_ID = '';
        this.paymentData.AUTH_NO = "";
        this.paymentData.WANTOK_GIFT_CARD = ''; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
      }
  }

  DATA_JSON(ACTION_BY, STATUS, WANTOK_CARD, BRANCH_ID, SOL, PAYMENT)
  {
      let DATA = {
				RunNo:0,
				DateTime:"",
				SOL_Total:0,
				Branch_ID:"",
        Card:"",
        Action_By:"",
        Status:"",
        Sales:[],
        Payment:[]
      }
      
      //DATA.RunNo = this.userRunNo;  // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      DATA.DateTime = this.formatDateTime();
      DATA.SOL_Total = (this.SOL_Array).length;
      DATA.Branch_ID = BRANCH_ID;
      DATA.Card = WANTOK_CARD;
      DATA.Action_By = ACTION_BY;
      DATA.Status = STATUS;
      DATA.Sales = SOL;
      DATA.Payment = PAYMENT;

      // [TCG:18/08/2020:IL/MPOS/20-04]:Added
      if(DATA.Branch_ID == "undefined" || DATA.Branch_ID == "") {
        DATA.Branch_ID = sessionStorage.getItem('userbranchid');
      }

      // [YOW:22/07/2020:CR/MPOS/20-03]:Added
      if (this.f_fleetPay == 1) {
        this.storage.get('runningNoData2').then((data) => {         //load runningNo
          if (data && data.length > 0) {
            this.userRunNo = data;
          }
          else {
            this.userRunNo = 0;
          }
  
          this.userRunNo = +this.userRunNo + 1;                     //offline add 1

          let val4 = JSON.stringify(this.userRunNo);
          this.storage.set('runningNoData2', val4);                 //save
          this.storage.set('lastSaleRunningNo', val4);

          this.storage.get('lastSO_NO2').then((data) => {           //load last SO_NO
            this.SO_NO = data;

            var tempData = this.SO_NO.substring(1);
            var tempData2 = parseInt(tempData);
            var localRunNo = + tempData2  + this.userRunNo;
            var runing10 = this.pad_with_zeroes(localRunNo , 10);
            var userid4 = this.pad_with_zeroes(ACTION_BY , 4);
            var sodatetime = this.SoDateTime();
            this.DATETIME_SO = 'CS' + userid4 + sodatetime + runing10;    //CS00252007110000002021
            DATA.RunNo = this.DATETIME_SO;
            this.DATA_Array.push(DATA);

            console.log('RunNo2' + this.DATETIME_SO);

            this.storage.set('lastLocalRunNo2', localRunNo);              //save for close sales upload to server
            this.storage.set('lastSaleSO_NO', this.DATETIME_SO);
            this.storage.set('lastSale_fleet', 1);

            this.storage.get('localData2').then((data) => {
              let val2 = "";
              let count = 0;
              
              for(count = 0;count <this.DATA_Array.length;count++)
              {
                val2 = this.DATA_Array[count];
                if(data != null)
                {
                    data.push(val2);
                    this.storage.set('localData2', data);
                }
                else
                {
                  let array = [];
                  array.push(val2);
                  this.storage.set('localData2', array);
                }
              }
            });

            this.continueDATA_JSON();
          });
        });
      }
      else {
        // [CXY:10/08/2020:CR/MPOS/20-03]:Added (Pay with Wantok Gift Card)
        if(this.f_wantokPay == 1) {
          this.storage.get('runningNoData3').then((data) => {         //load runningNo
            if (data && data.length > 0) {
              this.userRunNo = data;
            }
            else {
              this.userRunNo = 0;
            }
    
            this.userRunNo = +this.userRunNo + 1;                     //offline add 1
  
            let val4 = JSON.stringify(this.userRunNo);
            this.storage.set('runningNoData3', val4);                 //save
            this.storage.set('lastSaleRunningNo', val4);
  
            this.storage.get('lastSO_NO3').then((data) => {           //load last SO_NO
              this.SO_NO = data;
  
              var tempData = this.SO_NO.substring(1);
              var tempData2 = parseInt(tempData);
              var localRunNo = + tempData2  + this.userRunNo;
              var runing10 = this.pad_with_zeroes(localRunNo , 10);
              var userid4 = this.pad_with_zeroes(ACTION_BY , 4);
              var sodatetime = this.SoDateTime();
              this.DATETIME_SO = 'GS' + userid4 + sodatetime + runing10;
              DATA.RunNo = this.DATETIME_SO;
              this.DATA_Array.push(DATA);

              console.log('RunNo3' + this.DATETIME_SO);
  
              this.storage.set('lastLocalRunNo3', localRunNo);              //save for close sales upload to server
              this.storage.set('lastSaleSO_NO', this.DATETIME_SO);
              this.storage.set('lastSale_wantokGC', 1);
  
              this.storage.get('localData2').then((data) => {
                let val2 = "";
                let count = 0;
                
                for(count = 0;count <this.DATA_Array.length;count++)
                {
                  val2 = this.DATA_Array[count];
                  if(data != null)
                  {
                      data.push(val2);
                      this.storage.set('localData2', data);
                  }
                  else
                  {
                    let array = [];
                    array.push(val2);
                    this.storage.set('localData2', array);
                  }
                }
              });
  
              this.continueDATA_JSON();
            });
          });
        }
        else {
          this.storage.get('runningNoData').then((data) => {        //load runningNo
            if (data && data.length > 0) {
              this.userRunNo = data;
            }
            else {
              this.userRunNo = 0;
            }
    
            this.userRunNo = +this.userRunNo + 1;                   //offline add 1
            let val4 = JSON.stringify(this.userRunNo);
            this.storage.set('runningNoData', val4);                //save
            this.storage.set('lastSaleRunningNo', val4);
            
            this.storage.get('lastSO_NO').then((data) => {          //load last SO_NO
              this.SO_NO = data;
  
              var tempData = this.SO_NO.substring(1);
              var tempData2 = parseInt(tempData);   
              var localRunNo = + tempData2  + this.userRunNo;
              var runing10 = this.pad_with_zeroes(localRunNo , 10);
              var userid4 = this.pad_with_zeroes(ACTION_BY , 4);
              var sodatetime = this.SoDateTime();
              this.DATETIME_SO = 'S' + userid4 + sodatetime + runing10;       //S00252007110000002021
              console.log('RunNo' + this.DATETIME_SO);
              DATA.RunNo = this.DATETIME_SO;
              this.DATA_Array.push(DATA);
  
              this.storage.set('lastLocalRunNo', localRunNo);                 //save for close sales upload to server
              this.storage.set('lastSaleSO_NO', this.DATETIME_SO);
              this.storage.set('lastSale_fleet', 0);
  
              this.continueDATA_JSON();
            });
          });
        }
      }
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
  continueDATA_JSON(){
    let val = JSON.stringify(this.DATA_Array);
    let array2 = [];                                 
    array2.push(val);
    this.storage.set('lastSalesData', array2);                    //store last sales for re-print function
    
    this.storage.get('closingData').then((data) => {
      let val2 = "";
      let count = 0;

      for(count = 0;count <this.DATA_Array.length;count++)
      {
        val2 = this.DATA_Array[count];
        if(data != null)
        {
          data.push(val2);
          this.storage.set('closingData', data);
        }
        else
        {
          let array = [];
          array.push(val2);
          this.storage.set('closingData', array);
        }
      }
    });

    this.printReceipt();
  }

  clearPay(){
    this.PAYMENT_Array = [];              //clear payment
    this.total_payment = 0;
    this.paymentBalance = null;
    this.f_fleetPay = 0;
    // START: [CXY:14/06/2020:CR/MPOS/20-01]:Added
    this.f_wantokPay = 0;
    this.wantokGiftCardNo = '';
    this.wantokGiftCardPin = '';
    this.single_payment = 0;
    // END: [CXY:14/06/2020:CR/MPOS/20-01]:Added
  }

  checkInternet(){
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      this.servicegvariable.InternetConnection = "Online";

    }, (err) => {
      this.servicegvariable.InternetConnection = "Offline";
    });
  }

  enterFleetCard(){

    //disable get online. To keep card data offline 210320
/*     if (this.servicegvariable.InternetConnection == 'Online'){ 
      
      this.paymentData.PAYMENT_TYPE_ID = '';

      this.errorMessage = null;
      this.cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      let tbl = ["CARD"];
      let column = ["CARD_NO"];
      let value = [this.cardNo];
      
      let tblkey = ["CORP_ID"];
      let fktbl = ["CORPORATE"];
      let fkkey = ["CORP_ID"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1"){
          let Records = result["Records"];
          this.cardData.CARD_ACTIVE = Records[0]["CARD_ACTIVE"];
          this.cardData.CORP_ACTIVE = Records[0]["CORP_ACTIVE"];
          this.loading.dismiss();

          if (this.cardData.CARD_ACTIVE != "YES")
            this.errorMessage = "Card Not Active.";
          else if (this.cardData.CORP_ACTIVE != "YES")
            this.errorMessage = "Corporate Not Active.";
          else {
            this.paymentData.PAYMENT_TYPE_ID = '3';
            this.cardData.CARD_NO = Records[0]["CARD_NO"];
            this.cardData.CAR_PLATE = Records[0]["CAR_PLATE"];
            this.cardData.CREDIT_LIMIT = Records[0]["CREDIT_LIMIT"];
            this.cardData.BALANCE = Records[0]["BALANCE"];
            this.cardData.CORP_ID = Records[0]["CORP_ID"];
            this.cardData.CORP_NAME = Records[0]["CORP_NAME"];
          }

        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
      });
    }
    else { */
      this.paymentData.PAYMENT_TYPE_ID = '';
      this.errorMessage = null;
      this.cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      this.showLoader();
      this.storage.get('cardData').then((data) => {
        this.tempcardData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.tempcardData[i]);
            for (let i=0; i<data.length; i++){
              if (this.cardNo == data[i].CARD_NO){
                this.cardData.CARD_ACTIVE = data[i].CARD_ACTIVE;
                this.cardData.CORP_ACTIVE = data[i].CORP_ACTIVE;

                if (this.cardData.CARD_ACTIVE != "YES")
                  this.errorMessage = "Card Not Active.";
                else if (this.cardData.CORP_ACTIVE != "YES")
                  this.errorMessage = "Corporate Not Active.";
                else {
                  this.paymentData.PAYMENT_TYPE_ID = '3';
                  this.cardData.CARD_NO = data[i].CARD_NO;
                  this.cardData.CAR_PLATE = data[i].CAR_PLATE;
                  this.cardData.CREDIT_LIMIT = data[i].CREDIT_LIMIT;
                  this.cardData.BALANCE = data[i].BALANCE;
                  this.cardData.CORP_ID = data[i].CORP_ID;
                  this.cardData.CORP_NAME = data[i].CORP_NAME;
                  this.exitFleetCard();
                }
              }
            }
            if (this.errorMessage == null){
              if (this.paymentData.PAYMENT_TYPE_ID == ''){
                this.errorMessage = "Card not found.";
              }
            }

            if (this.errorMessage != null){
              let confirm = this.alertCtrl.create({
                title: 'Error',
                message: this.errorMessage,
                buttons: [
                  {
                    text: 'Confirm',
                    handler: () => {
                    console.log('Agree clicked');
                    }
                  }
                ]
              });
              confirm.present();
            }
            this.cardNo = null;
          }
        }
        this.loading.dismiss();
      });
    
  }

  hideOverlay()
  {
    this.overlayHidden = true;
  }
  exitFleetCard(){
    this.overlayHidden = true;
  }

  scanCode(){
    this.barcodeScanner.scan().then(barcodeData => {
      this.cardNo = barcodeData.text;
      this.enterFleetCard();
    }, (err) => {
        console.log('Error: ', err);
    });
  }

  scanWantok(){
    this.barcodeScanner.scan().then(barcodeData => {
      this.wantokCard = barcodeData.text;

    }, (err) => {
        console.log('Error: ', err);
    });
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      dismissOnPageChange: true
    });

    toast.present();
  }

  pad_with_zeroes(number, length) {                                   //routine to add 0 infront number

    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  popupWantokGiftCard() {
    this.errorMessage = '';
    this.overlayHidden_WGC = false;
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  hideOverlay_WGC() {
    this.errorMessage = '';
    this.wantokGiftCardNo = '';
    this.wantokGiftCardPin = '';
    this.overlayHidden_WGC = true;
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  scanWantokGiftCard() {
    this.barcodeScanner.scan().then(barcodeData => {
      this.wantokGiftCardNo = barcodeData.text;
    }, (err) => {
        console.log('Error: ', err);
    });
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  validateWantokGiftCard() {
    if(this.wantokGiftCardNo == '' || this.wantokGiftCardNo == undefined) {
      this.errorMessage = 'Card Number should not leave blank';
      return;
    }
    if(this.wantokGiftCardPin == '' || this.wantokGiftCardPin == undefined) {
      this.errorMessage = 'Card Pin should not leave blank';
      return;
    }
    if(this.single_payment == 0 || this.single_payment == null || this.single_payment == undefined) {
      this.errorMessage = 'Amount should not leave blank';
      return;
    }
    this.pay();
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  payWantokGiftCard() {
    let WGC_PaymentData = {
      OrderId:'',
      Branch:'',
      CardNo:'',
      Amount:0
    }

    let wantokPayLength = this.PAYMENT_Array.length;
    let wantokSONo = 0;
    WGC_PaymentData.OrderId = this.SO_NO.replace(/"/g,"").slice(-10);
    wantokSONo = parseInt(WGC_PaymentData.OrderId) + this.userRunNo;
    WGC_PaymentData.OrderId = this.SO_NO.replace(/"/g,"").slice(0,7) + this.pad_with_zeroes(wantokSONo, 10);
    WGC_PaymentData.Branch = this.companyData.COMPANY;

    for(let i=0; i<wantokPayLength; i++) {
      if(this.PAYMENT_Array[i].PAYMENT_TYPE_ID == '7') {
        WGC_PaymentData.CardNo = this.PAYMENT_Array[i].WANTOK_GIFT_CARD;
        WGC_PaymentData.Amount = this.PAYMENT_Array[i].AMOUNT_TENDER;

        this.serviceapi.payWantokPayment(WGC_PaymentData).then((result) => {
          this.Status = result['responseCode'];
          if (this.Status == 'APPROVED') {
            this.loading.dismiss();
          }
          else {
            this.errorAlert(result['Message']);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
    }
  }

  // [CXY:03/07/2020:CR/MPOS/20-01]:Added
  checkWGCBalance() {
    this.errorMessage = '';
    if(this.wantokGiftCardNo == '' || this.wantokGiftCardNo == undefined) {
      this.errorMessage = 'Card Number should not leave blank';
      return;
    }

    let WGC_CardData = {
      CardNo:''
    }
    WGC_CardData.CardNo = this.wantokGiftCardNo;
    this.showLoader();
    this.serviceapi.checkWantokGiftCardBalance(WGC_CardData).then((result) => {
      this.Status = result['responseCode'];
      if (this.Status == 'SUCCESS') {
        this.message = "Card Balance: " + result['CardBalance'];
        this.loading.dismiss();
      }
      else {
        this.errorMessage = result['Message'];
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/b01-d02-sales-payment/b01-d02-sales-payment.ts